// JsFromRoutes CacheKey 193188d57cf3187275d41f6c6d1f5b9e
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  passthru: definePathHelper('get|post', '/users/auth/google_oauth2'),
  googleOauth2: definePathHelper('get|post', '/users/auth/google_oauth2/callback'),
}
